import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Modules
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';

// Other imports
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { AdminWidgetComponent } from './admin-widget/admin-widget.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { IonicModule } from '@ionic/angular';
import { ViewMockserverSettingsComponent } from './admin-widget/view-mockserver-settings/view-mockserver-settings.component';
import { ServerBusyComponent } from './serverRelated/server-busy/server-busy.component';
import { UnavailableTextComponent } from './serverRelated/unavailable-text/unavailable-text.component';
import { EstTimePipe } from './pipes/est-time-pipe/est-time.pipe';
// import { OffersComparisonComponent } from './offers-comparison/offers-comparison.component';
// import { ConformationModalComponent } from './conformation-modal/conformation-modal.component';

@NgModule({
  declarations: [
    // ConformationModalComponent
    AdminWidgetComponent,
    ViewMockserverSettingsComponent,
    ServerBusyComponent,
    UnavailableTextComponent,
    EstTimePipe,
    // OffersComparisonComponent
  ],
  imports: [
    CommonModule,
    NzPopoverModule,
    NzTableModule,
    NzDividerModule,
    NzSpinModule,
    NzSelectModule,
    NzButtonModule,
    FormsModule,
    MaterialModule,
    IonicModule,
    NzDropDownModule,
    NzIconModule,
    NzInputModule,
    NzModalModule
  ],
  exports: [
    NzPopoverModule,
    NzTableModule,
    NzDividerModule,
    NzSpinModule,
    AdminWidgetComponent,
    FormsModule,
    MaterialModule,
    IonicModule,
    NzDropDownModule,
    NzIconModule,
    NzInputModule,
    ServerBusyComponent,
    UnavailableTextComponent,
    EstTimePipe,
    // OffersComparisonComponent
  ],
  providers: [{ provide: NZ_I18N, useValue: en_US }],
})
export class SharedModuleModule { }
